module.exports = __webpack_public_path__ + "static/media/mercearia-1.b4632072.jpg";